@if (!hideMenuTriggerButton()) {
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>attach_file</mat-icon>
  </button>
}

<mat-menu #menu="matMenu">
  @for (attachment of attachments(); track attachment) {
    <button mat-menu-item (click)="downloadAttachment(attachment)">
      {{ attachment.name }}
    </button>
  }
</mat-menu>
